/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'double_arrow_right': {
    width: 16,
    height: 16,
    viewBox: '0 0 14.83 16.83',
    data: '<path pid="0" d="M1.41 16.83L0 15.41l7-7-7-7L1.41 0l8.42 8.41-8.42 8.42z"/><path pid="1" d="M6.41 16.83L5 15.41l7-7-7-7L6.41 0l8.42 8.41-8.42 8.42z"/>'
  }
})
